import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
@Directive({ selector: '[titleCase]' })
export class TitleCaseDirective implements OnInit {
  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef, public titleCase: TitleCasePipe) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.el.value = this.titleCase.transform(this.el.value);
  }

  @HostListener('input', ['$event.target.value'])
  onKeyDown(value) {
    this.el.value = this.titleCase.transform(value);
  }
}
